import React from "react";

import { StyledHighlight, StyledImage, StyledTitle } from "./style";

const Highlight = ({ image, title }) => (
  <StyledHighlight>
    <StyledImage src={image} />
    <StyledTitle variant="label2">{title}</StyledTitle>
  </StyledHighlight>
);

export default Highlight;
